import { render } from "./VoucherView.vue?vue&type=template&id=45e86e60"
import script from "./VoucherView.vue?vue&type=script&lang=ts"
export * from "./VoucherView.vue?vue&type=script&lang=ts"
script.render = render

export default script